<!--
 * @Description: 我的运单
 * @Author: ganjia
 * @Date: 2019-10-11 10:09:33
 -->
<template>
  <div class="main-wrap waybill">
    <div class="waybill-top">
      <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
      <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
      <div class="waybill-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <div class="radioBox">
            <el-radio v-model="searchParam.timeType" :label="2">{{ $lang('揽收时间') }}</el-radio>
            <el-radio v-model="searchParam.timeType" :label="3">{{ $lang('签收时间') }}</el-radio>
          </div>
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="datetimerange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item prop="ids">
            <base-input-tag
              style="width:220px"
              v-model="searchParam.ids"
              :placeholder="$lang('请输入订单编号(最多可查200条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
               ref="BaseInputTag2"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item> -->
          <el-form-item prop="waybillNos">
            <!-- <el-input v-model="searchParam.waybillNo" placeholder="请输入运单编号"></el-input> -->
            <base-input-tag
              style="width:210px"
              v-model="searchParam.waybillNos"
              :placeholder="$lang('请输入运单编号(最多可查200条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="customerOrderIds">
            <!-- <el-input v-model="searchParam.waybillNo" placeholder="请输入运单编号"></el-input> -->
            <base-input-tag
              style="width:230px"
              v-model="searchParam.customerOrderIds"
              :placeholder="$lang('请输入客户订单号(最多可查200条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag3"
              validate="isSymbolNumberLetter"
              class="cms-input-tag">
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item prop="expressTypeCodeList" class="expressTypeCodeList-input">
            <el-select v-model="searchParam.expressTypeCodeList" multiple collapse-tags :placeholder="$lang('请选择快递类型')" :clearable="true" filterable class="vipsBox">
              <el-option
                v-for="item in productTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
           <el-form-item prop="isVip" >
          <el-select v-model="searchParam.isVip"  :placeholder="$lang('请选择订单来源')" :clearable="true" filterable class="vipsBox">
            <el-option
              v-for="item in isVipList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="inputStaffBy" >
          <el-select v-model="searchParam.inputStaffBy"  :placeholder="$lang('请选择子账号')" :clearable="true" filterable class="vipsBox">
            <el-option
              v-for="item in findChildAccountList"
              :key="item.id"
              :label="item.account"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="thirdPartyWaybillIds">
          <base-input-tag
            style="width:230px"
            v-model="searchParam.thirdPartyWaybillIds"
            :placeholder="$lang('请输入三方运单号(最多可查200条)')"
            :clearBtnVisible="true"
            ref="BaseInputTag4"
            :addTagOnBlur="true"
            class="cms-input-tag">
          </base-input-tag>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="waybill-bottom">
      <div class="waybill-nav">
        <div class="waybill-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index, item.waybillStatusCode)" :class="{ active: tabActive === item.waybillStatusCode }">
          {{ item.waybillStatusName }}<span class="waybill-nav-item-count">{{ item.count }}</span>
        </div>
      </div>

      <JmsTable
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
        :summaryMethod="summaryMethod"
      >
        <template slot="waybillStatusCode" slot-scope="data">
          <div>
            <!-- 201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件 -->
            <span v-show="data.row.waybillStatusCode == 201">{{ $lang('已揽件') }}</span>
            <span v-show="data.row.waybillStatusCode == 202">{{ $lang('已发件') }}</span>
            <span v-show="data.row.waybillStatusCode == 203">{{ $lang('运送中') }}</span>
            <span v-show="data.row.waybillStatusCode == 204">{{ $lang('派件中') }}</span>
            <span v-show="data.row.waybillStatusCode == 205">{{ $lang('已签收') }}</span>
            <span v-show="data.row.waybillStatusCode == 206">{{ $lang('退件中') }}</span>
            <span v-show="data.row.waybillStatusCode == 207">{{ $lang('已退件') }}</span>
            <span v-show="data.row.waybillStatusCode == 208">{{ $lang('已拒收') }}</span>
            <span v-show="data.row.waybillStatusCode == 209">{{ $lang('已转寄') }}</span>
          </div>
        </template>
        <!-- 运单号 -->
        <template slot="waybillNo" slot-scope="data">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(data)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(data.row.waybillNo)" class="getExpressTracking">{{ data.row.waybillNo }}</span>
          </el-tooltip>
        </template>

        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
            <el-button v-if="permission(data.row) && showEdit(data.row.waybillStatusCode) && (data.row.codMoney || data.row.codMoney === 0) && data.row.expressTypeCode !== 'BC' && data.row.expressTypeCode !== 'RC'" @click="rowEdit(data.row, 'cod')" type="text"
            :title="$lang('修改COD')">{{ $lang('修改COD') }}
            </el-button>
            <el-button v-if="(data.row.waybillStatusCode===201||data.row.waybillStatusCode===203||data.row.waybillStatusCode===206||data.row.waybillStatusCode===204) && data.row.expressTypeCode !== 'BC' && data.row.expressTypeCode !== 'RC'" @click="openComprehensive(data.row)" type="text" :title="$lang('综合修改')">{{ $lang('综合修改') }}</el-button>
            <el-button @click="showLog(data.row)" type="text"  :title="$lang('修改详情')">{{ $lang('修改详情') }}</el-button>
            <!-- 删除按钮 -->
            <!--                    <el-button v-show="data.row.waybillStatusCode==205||data.row.waybillStatusCode==207" @click="rowDel({ id: data.row.id })" type="text" icon="iconfont iconshanchu font-16"></el-button>-->
            <!-- <el-button
              v-show="data.row.waybillStatusCode == 205 || data.row.waybillStatusCode == 207"
              @click="rowDel({ waybillNo: data.row.waybillNo })"
              type="text"
            >{{ $lang('删除') }}</el-button> -->
          </div>
        </template>
      </JmsTable>
    </div>

    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" @imgDialogChange="imgDialogChange" :bulletTitle="2" :rowData="rowData"></bullet>
    <!-- 导出订单弹框组件 -->
    <!-- <export-componet
      ref="exportComponet"
      :cityOptions="cityOptions"
      :exportVisible="exportVisible"
      :idsLength="selection.length"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet> -->

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
    <waybill-edit :rowData="rowData" ref="WaybillEdit" :editType="editType" :waybillLogStatus="waybillLogStatus" @saveHandler="saveHandler"/>
    <ComprehensiveEdit :visible.sync="cancelVisible" :rowData="rowData" ref="ComprehensiveEdit"  @submit="pullUpdata"/>
    <waybill-log ref="waybillLog"/>
  </div>
</template>
<script>
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { waybillOrder, countByStatus, asyExportWaybill, waybillDelete, getDetailById, queryCustomerOrderSource, modifyCod, waybillLogByCode, findChildAccount, getExpressType } from '@api/module/customer'
import bullet from '@components/base/BaseBullet.vue'
// import exportComponet from '@components/base/BaseExport.vue'
import { RESPONSE_SUCCESS } from '@constants'
import { commonFun } from '@utils/common'
import { mapGetters } from 'vuex'
import WaybillEdit from './components/WaybillEdit.vue'
import WaybillLog from './components/WaybillLog.vue'
import ComprehensiveEdit from './components/ComprehensiveEdit.vue'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'

export default {
  name: 'Waybill',
  mixins: [mixin],
  components: {
    JmsTable,
    bullet,
    // exportComponet,
    ExportDownloadDialog,
    ComprehensiveEdit,
    WaybillEdit,
    WaybillLog,
  },
  data() {
    const _this = this
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 180 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = _this.$dayjs(new Date().getTime()).format('YYYY-MM-DD') + ' 23:59:59'
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
      isVipList: [{ name: this.$lang('VIP'), lable: 1, code: 1 }, { name: this.$lang('非VIP'), lable: 2, code: 2 }],
      COM_HTTP: {
        reqList: waybillOrder,
        // reqExcel: waybillExport,
        reqExcel: asyExportWaybill,
        reqDel: waybillDelete,
        reqDetail: getDetailById,
      },
      isShowFirst: false,
      cancelVisible: false,
      searchParam: {
        timeType: 2,
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        waybillNos: [], // 运单号
        receiverMobilePhone: '', // 收件人手机号
        waybillStatusCode: 0, // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        current: 1, // 当前页
        isVip: '',
        inputStaffBy: '',
        pageSize: 20, // 每页显示记录数
        orderSourceCode: '',
        customerOrderIds: [],
        thirdPartyWaybillIds: [], // 三方运单号
        expressTypeCodeList: [],
        // ids: ['296551412484018181'],
        // orderSourceCodes: [],
      },
      menuItems: [], // 导航栏
      activeIndex: '0',
      selection: [],
      exportVisible: false, // 导出弹框显示
      excelParams: {},
      exportStatus: 'all',
      exportType: 2, // 1：订单； 2：运单
      exportLoading: false,
      exportData: {},
      cityOptions: [],
      delTitObj: {
        title: this.$lang('删除运单'),
        subTitle: this.$lang('你确定要删除已选中的运单吗？'),
        threeTitle: '',
      },
      orderSourceCodeList: [{ groupOrderSourceName: '全部', groupOrderSourceCode: '' }],
      tabActive: 0,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'my_waybill_qy', // 我的订单
      editType: 'phone',
      waybillLogStatus: '',
      findChildAccountList: [],
      productTypeList: [], // 产品类型
    }
  },
  async created() {
    this.init()
  },
  computed: {
    ...mapGetters([
      'user',
      'viewAllData',
      'operationAllData'
    ]),
    listOpt() {
      const that = this
      return {
        border: true,
        selection: true,
        menu: true,
        dynamicOptions: {
          getUrl: '/vip/configuration/queryWaybillConfiguration',
          defaultUrl: '/vip/configuration/saveOrUpdateWaybillConfiguration',
          saveUrl: '/vip/configuration/saveOrUpdateWaybillConfiguration',
        },
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        menuWidth: 250,
        showSummary: true,
        selectable: (row, index) => {
          return that.permission(row)
        },
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('运单编号'),
            prop: 'waybillNo',
            width: 200,
            slot: true,
          },
          {
            label: this.$lang('状态'), //  运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
            prop: 'waybillStatusCode',
            slot: true,
          },
          {
            label: this.$lang('订单来源'),
            prop: 'orderSourceName',
            formatter: (row, value, label, column) => {
              return row.orderSourceName === 'VIP' ? that.$lang('VIP') : that.$lang('非VIP')
            },
            width: 200,
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150,
          },
          {
            label: this.$lang('收件人姓名'),
            prop: 'receiverName',
            width: 90,
          },
          // {
          //   label: this.$lang('收件方区号'),
          //   prop: 'receiverName',
          // },
          {
            label: this.$lang('收件人电话'),
            prop: 'receiverMobilePhone',
            width: 100,
          },
          {
            label: this.$lang('收件人电话2'),
            prop: 'receiverTelphone',
            width: 100,
          },
          // {
          //   label: this.$lang('收件房号'),
          //   prop: 'receiverRoomNumber',
          //   // width: 200,
          // },
          // {
          //   label: this.$lang('收件楼层'),
          //   prop: 'receiverFloor',
          // },
          // {
          //   label: this.$lang('收件楼号'),
          //   prop: 'receiverBuildingNo',
          // },
          {
            label: this.$lang('收件街道'),
            prop: 'receiverStreet',
          },
          {
            label: this.$lang('收件地区'),
            prop: 'receiverAreaName',
          },
          {
            label: this.$lang('收件城市'),
            prop: 'receiverCityName',
            width: 90,
          },
          {
            label: this.$lang('收件省'),
            prop: 'receiverProvinceName',
            width: 90,
          },
          // {
          //   label: this.$lang('派件备注'),
          //   prop: 'receiverRemark',
          //   width: 150,
          // },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName',
          },

          {
            label: this.$lang('物品名称'),
            prop: 'goodsName',
          },
          {
            label: this.$lang('计费重量(KG)'),
            prop: 'packageChargeWeight',
            width: 100
          },
          {
            label: this.$lang('物品重量(KG)'),
            prop: 'packageTotalWeight',
            width: 100
          },
          // {
          //   label: this.$lang('物品价值'),
          //   prop: 'insuredAmount',
          // },
          // {
          //   label: this.$lang('包裹数量'),
          //   prop: 'packageNumber',
          // },
          // {
          //   label: this.$lang('长/宽/高'),
          //   prop: 'machine',
          //   formatter: (row, value, label, column) => {
          //     return `${row.packageLength !== undefined && row.packageLength !== null ? (row.packageLength + '/') : ''}${row.packageWide !== undefined && row.packageWide !== null ? (row.packageWide + '/') : ''}${row.packageHigh !== undefined && row.packageHigh !== null ? row.packageHigh : ''}`
          //   },
          //   width: 100,
          // },
          {
            label: this.$lang('保险价值'),
            prop: 'insuredAmount',
          },
          {
            label: this.$lang('保价费'),
            prop: 'insuredFee',
          },
          {
            label: this.$lang('快递类型'),
            prop: 'expressTypeName',
          },
          {
            label: this.$lang('结算方式'),
            prop: 'settlementName',
          },
          {
            label: this.$lang('支付方式'),
            prop: 'paidModeName',
          },
          // {
          //   label: this.$lang('平台'),
          //   prop: 'platformName',
          // },
          // {
          //   label: this.$lang('客户账号'),
          //   prop: 'customerAccount',
          // },
          {
            label: this.$lang('代收货款金额'),
            prop: 'codMoney',
            width: 100,
          },
          {
            label: this.$lang('代收货款手续费'),
            prop: 'codFee',
            width: 110,
          },
          // {
          //   label: this.$lang('件数'),
          //   prop: 'packageNumber',
          // },
          // {
          //   label: this.$lang('保价费'),
          //   prop: 'insuredFee',
          // },
          {
            label: this.$lang('参考运费'),
            prop: 'totalFreight',
            show: this.user.freightStatus === 1,
          },
          {
            label: this.$lang('拣货信息'),
            prop: 'customerPickInfo',
          },
          {
            label: this.$lang('派件天次'),
            prop: 'numberOfDispatch',
          },
          {
            label: this.$lang('异常件描述'),
            prop: 'exceptionReason',
            width: 100,
          },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            width: 200,
          },
          {
            label: this.$lang('下单账户名称'),
            prop: 'inputStaffCode',
            width: 100,
          },
          {
            label: this.$lang('揽收时间'),
            prop: 'collectTime',
            width: 200,
          },
          {
            label: this.$lang('签收时间'),
            prop: 'signTime',
            width: 200,
          },
        ],
      }
    },
  },
  watch: {
    $route(newV, oldV) {
      if (oldV.name === 'home') {
        this.init()
      }
    },
  },
  methods: {
    async init() {
      const key = this.$route.params.typeNum
      const waybillHomeQuery = JSON.parse(sessionStorage.getItem('waybillHomeQuery'))
      if (waybillHomeQuery) {
        this.tabActive = waybillHomeQuery.waybillStatusCode
        this.searchParam.waybillStatusCode = waybillHomeQuery.waybillStatusCode
        this.searchParam.date = waybillHomeQuery.date
        this.searchParam.startTime = waybillHomeQuery.startTime
        this.searchParam.endTime = waybillHomeQuery.endTime
      }
      // this.getOrderOrigin(key)
      this.getFindChildAccount()
      this.getProductTypeList()
      await this.countByStatus()
      if (key) {
        this.handleSelect(key)
      } else {
        this.searchFun()
      }
    },
    // 获取产品类型下拉列表
    async getProductTypeList() {
      const { code, data, msg } = await getExpressType({ type: 1 })
      if (code === RESPONSE_SUCCESS) {
        this.productTypeList = data
      } else {
        this.$message.error(msg)
      }
    },
    permission(row) {
      const { isSelf } = row
      const { operationAllData } = this
      const isMasterAcc = this.user.parentId === 0
      return isMasterAcc || (!isMasterAcc && (operationAllData || isSelf))
    },
    pullUpdata() {
      this.searchFun()
      this.countByStatus()
    },
    async saveHandler(val, cb) {
      console.log(val, cb)
      const { waybillNo, beforeCodMoney, afterCodMoney } = val
      let res = null
      try {
        res = await modifyCod({
          waybillNo,
          beforeCodMoney,
          afterCodMoney,
        })
        if (res && res.succ) {
          this.$message.success(this.$lang('修改成功'))
          cb(true)
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取子账号
    async getFindChildAccount() {
      const { code, data, msg } = await findChildAccount()
      if (code === RESPONSE_SUCCESS) {
        this.findChildAccountList = data
      } else {
        this.$message.error(msg)
      }
    },
    async rowEdit (row, type) {
      await this.viewFun(row)
      this.editType = type
      type === 'cod' && await this.getWaybillLogByCode(row.waybillNo)
      this.$refs.WaybillEdit.showDialog()
    },
    async openComprehensive(row) {
      await this.viewFun(row)
      this.cancelVisible = true
      console.log(3333)
    },
    showLog(row) {
      console.log(row)
      this.$refs.waybillLog.showDialog(row.waybillNo)
    },
    showEdit(status) {
      return [201, 202, 203, 204, 206, 208, 209].includes(status)
    },
    async getWaybillLogByCode(waybillNo) {
      try {
        const res = await waybillLogByCode({ waybillNo })
        if (res && res.succ) {
          this.waybillLogStatus = res.data ? res.data.status : ''
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillNo
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.selection = []
    },
    // 获取下单渠道下拉数据，请求列表数据
    async getOrderOrigin(key) {
      try {
        const { code, data } = await queryCustomerOrderSource()

        if (code === RESPONSE_SUCCESS) {
          if (data.length) {
            this.orderSourceCodeList = this.orderSourceCodeList.concat(data)
          } else {
            this.orderSourceCodeList = []
          }
          await this.countByStatus()
          if (key) {
            this.handleSelect(key)
          } else {
            this.searchFun()
          }
        } else {
          this.orderSourceCodeList = []
        }
      } catch (error) {
        this.orderSourceCodeList = []
      }
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.selection = []
    },
    // 查看方法
    async viewFun(row) {
      if (this.isRowDetailUrl) {
        const { data, code, msg } = await this.COM_HTTP.reqDetail({ waybillNo: row.waybillNo }) // 根据运单号
        if (code === RESPONSE_SUCCESS) {
          console.log('查看调用成功')
          // 回显数据
          const newRow = this.handleData(data)
          this.rowData = Object.assign({}, { ...newRow })
        } else {
          this.$message.error(msg)
        }
      } else {
        // 回显数据
        this.rowData = this.handleData(row)
      }
    },
    // 删除方法
    async deleteFun(item) {
      const res = await this.COM_HTTP.reqDel(item)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.afterDelSuccess()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 触发按钮查询
    searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      const homeQuery = {
        waybillStatusCode: this.tabActive,
        startTime: this.searchParam.startTime,
        endTime: this.searchParam.endTime,
        date: [this.searchParam.startTime, this.searchParam.endTime],
      }
      sessionStorage.setItem('waybillHomeQuery', JSON.stringify(homeQuery))
      if (endTime - startTime > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      // this.searchParam.waybillStatusCode = this.menuItems[this.activeIndex].waybillStatusCode

      const { waybillNos, customerOrderIds, thirdPartyWaybillIds } = this.searchParam
      // 处理运单编号
      if (waybillNos && waybillNos.length !== 0) {
        if (waybillNos.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条运单'))
        }
      }
      // 处理客户订单号
      if (customerOrderIds && customerOrderIds.length !== 0) {
        if (customerOrderIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条客户订单'))
        }
      }
      // 三方运单号200条限制
      if (thirdPartyWaybillIds && thirdPartyWaybillIds.length !== 0) {
        if (thirdPartyWaybillIds.length > 200) {
          return this.$message.warning(this.$lang('请勿超过200条三方运单号'))
        }
      }
      this.searchFun(1)
      this.countByStatus()
    },
    // 搜索-获取参数
    getParams() {
      const { startTime, endTime, waybillNos, receiverMobilePhone, waybillStatusCode, customerOrderIds, isVip, timeType, inputStaffBy, thirdPartyWaybillIds, expressTypeCodeList } = this.searchParam
      return {
        pageSize: this.page.size,
        startTime: waybillNos.length || customerOrderIds.length || receiverMobilePhone || thirdPartyWaybillIds.length ? '' : startTime,
        endTime: waybillNos.length || customerOrderIds.length || receiverMobilePhone || thirdPartyWaybillIds.length ? '' : endTime,
        waybillNos, // 运单号
        isVip,
        inputStaffBy,
        timeType,
        receiverMobilePhone, // 收件人手机号
        // ids,
        customerOrderIds,
        waybillStatusCode: waybillStatusCode, // 运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        thirdPartyWaybillIds,
        expressTypeCodeList
        // orderSourceCodes: this.getOrderOriginCode(orderSourceCode), // 下单渠道
      }
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      // 获取选中行的数量
      const len = (this.selection && this.selection.length) || 0
      // 选中行ids处理（未选中不穿此参数）
      if (len) ids = this.selection.map(item => item.id)
      // 处理导出表格的属性字段
      this.cityOptions.forEach(item => {
        sort.push(item.prop)
        columnNames.push(item.name)
      })
      let params = { ids, sort, columnNames, orderStatusCode: this.exportStatus }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      return params
    },
    // 快捷菜单搜索
    handleSelect(key) {
      const menuItems = this.menuItems
      const { waybillStatusCode } = menuItems[key]
      this.searchParam.waybillStatusCode = waybillStatusCode
      this.exportStatus = waybillStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.searchFun()
      this.countByStatus()
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const collectTime = {
        key: 'collectTime',
        prop: 'collectTime',
        name: this.$lang('揽收时间'),
      }
      const dispatchTime = {
        key: 'dispatchTime',
        prop: 'dispatchTime',
        name: this.$lang('派件时间'),
      }
      const signTime = {
        key: 'signTime',
        prop: 'signTime',
        name: this.$lang('签收时间'),
      }
      // refundTime 退件时间？
      const refundTime = {
        key: 'refundTime',
        prop: 'refundTime',
        name: this.$lang('退件签收时间'),
      }
      // inputTime 录入时间？
      const inputTime = {
        key: 'inputTime',
        prop: 'inputTime',
        name: this.$lang('运送时间'),
      }
      // this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
      switch (key) {
        case 0: // 全部运单
          this.cityOptions.push(collectTime, dispatchTime, signTime, refundTime)
          break
        case 1: // 已揽件
          this.cityOptions.push(collectTime)
          break
        case 2: // 运送中
          this.cityOptions.push(inputTime)
          break
        case 3: // 派送中
          this.cityOptions.push(dispatchTime)
          break
        case 4: // 已签收
          this.cityOptions.push(signTime)
          break
        case 5: // 退件中
          break
        case 6: // 已退件
          this.cityOptions.push(inputTime)
          break
        default:
          // 默认
          break
      }
    },
    // 删除
    delFn() {
      this.$refs.delOrder.dialogTableVisible = true
    },
    // 打开导出弹框
    async exportOpen() {
      if (this.selection.length <= 0) {
        this.exportLoading = true
        await this.countByStatus()
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].count || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.cityOptions = [...this.$refs.table.dynamicColumns.filter(item => item.show)]
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.user.freightStatus === 0) {
        const chooseIndex = this.cityOptions.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.cityOptions.splice(chooseIndex, 1)
      }
      this.updateOutExcel(this.currentKey)
      // this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
      this.exportFn()
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出数据
    async exportFn(status, data, dataParams) {
      // this.exportVisible = status
      // this.columnList = data
      // this.excelParams = dataParams
      // 调用导出方法
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportWaybill()
    },
    async asyExportWaybill() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请前往下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startTime = start
        this.searchParam.endTime = end
      }
    },
    // 获取运单状态列表
    async countByStatus() {
      const { startTime, endTime, waybillNos, receiverMobilePhone, customerOrderIds, isVip, timeType, inputStaffBy, thirdPartyWaybillIds, expressTypeCodeList } = this.searchParam
      const params = {
        startTime: waybillNos.length || customerOrderIds.length || receiverMobilePhone || thirdPartyWaybillIds.length ? '' : startTime,
        endTime: waybillNos.length || customerOrderIds.length || receiverMobilePhone || thirdPartyWaybillIds.length ? '' : endTime,
        waybillNos, // 运单号
        isVip,
        inputStaffBy,
        timeType,
        customerOrderIds, // 客户订单号
        receiverMobilePhone, // 收件人手机号
        thirdPartyWaybillIds,
        expressTypeCodeList
        // orderSourceCodes: this.getOrderOriginCode(orderSourceCode), // 下单渠道
      }
      console.log('params++++', params)
      const { code, data } = await countByStatus(params)
      if (code === 1) {
        this.menuItems = data
      }
    },
    getOrderOriginCode(orderSourceCode) {
      let codes = []
      if (!orderSourceCode) {
        const dataCodes = this.orderSourceCodeList.map(item => item.groupOrderSourceCode)
        codes = dataCodes
      } else {
        codes = [orderSourceCode]
      }
      return codes
    },
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
    },
    imgDialogChange(val) {
      if (val) this.viewDialogVisible = false
      if (!val) this.viewDialogVisible = true
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0],
        endTime: commonFun.GetTodayDate()[1],
        orderSourceCode: '',
        timeType: 2,
        inputStaffBy: '',
        // orderSourceCodes: [],
        customerOrderIds: [],
      }
      this.$refs.BaseInputTag1.clearFn()
      // this.$refs.BaseInputTag2.clearFn()
      this.$refs.BaseInputTag3.clearFn()
    },
    // 表格复选框选择回调
    selectionChange(val) {
      this.selection = val
    },
    // 删除后的回调
    afterDelSuccess() {
      this.searchFun(1)
      setTimeout(this.countByStatus, 500)
    },
    changeTab(index, waybillStatusCode) {
      this.tabActive = waybillStatusCode
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    // 单页统计数据
    summaryMethod(param) {
      const { columns } = param
      const columnTypeList = [
        'codMoney',
        'codFee',
        'totalFreight',
      ]
      const sums = []
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$lang('总计')
            return
          }

          const findIndex = columnTypeList.findIndex(item => item === column.property)

          switch (findIndex) {
            case 0:
              sums[index] = this.totalCodMoney
              return
            case 1:
              sums[index] = this.totalCodFee
              return
            case 2:
              sums[index] = this.totalFreight
              return
          }
          sums[index] = this.$lang('--')
        })
      }
      return sums
    },
    // 搜索成功之后
    searchAfterFun() {
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
// @import '@assets/iconfont/iconfont.css
.el-form-item {
  margin-bottom: 0;
}

.radioBox {
  margin: 10px;
}

.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}

.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}

.waybill {
  .waybill-top {
    //   padding :24px;
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }

    .waybill-topLeft {
      margin-top: 10px;
    }
  }

  .waybill-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .waybill-nav {
    //   margin: 9px 0;
    .waybill-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      //   width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }

      i {
        margin-right: 8px;
        color: #666;
      }

      &.active {
        background: #fff;
        color: #e60012;

        i {
          color: #e60012;
        }
      }
    }

    .waybill-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>

<style lang="scss">
.vipsBox {
  .el-input__prefix, .el-input__suffix {
    top: -4px;
  }
}

.waybill .waybill-top .el-input__inner {
  margin-bottom: 10px;
}

.expressTypeCodeList-input {
  .el-input__inner, input {
    max-height: 34px;
  }
  .el-select__tags {
    height: 30px;
  }
  .el-tag {
    max-width: 83px;
    overflow: hidden;
  }
}
</style>
